import React from 'react';
import { bucketFor } from '../lib/ratingScale';

export default function RatingColorBar({ value, max = 100, height = 8, showValue = false, tone = 'quality' }) {
  const v = value == null ? 0 : Math.max(0, Math.min(max, Number(value)));
  const pct = max > 0 ? (v / max) * 100 : 0;
  const { hex } = bucketFor(value, { tone });
  return (
    <div className="w-full">
      <div
        className="w-full rounded-full bg-gray-100 dark:bg-gray-800 overflow-hidden"
        style={{ height }}
      >
        <div
          className="h-full rounded-full"
          style={{ width: `${pct}%`, backgroundColor: hex, transition: 'width 200ms ease' }}
        />
      </div>
      {showValue && (
        <div className="text-xs mt-1 text-gray-600 dark:text-gray-400">
          {value == null ? '—' : `${Number(value).toFixed(1)}`}
        </div>
      )}
    </div>
  );
}
